'use client'

const RadioFilter = ({
  filters,
  radioSelected,
  setRadioSelected,
  textMinimal = false,
  hiddeText = false,
  className
}) => {
  return (
    <fieldset>
      <div className={`${className} grid grid-cols-1 lg:flex`}>
        {!hiddeText && (
          <div className="flex bg-sec-grey-4 p-5 rounded-l-sm border-white border-r-2 lg:border-r-2">
            <p className="block text-[16px] lg:text-[22px] font-alliance-medium text-blue">
              {textMinimal ? 'FILTRAR' : 'FILTRAR PER'}
            </p>
          </div>
        )}
        <div className="flex bg-sec-grey-4 p-5 rounded-r-sm">
          {filters.map((option) => (
            <div key={option.value} className="flex items-center mr-5">
              <input
                id={option.value}
                name={option.value}
                value={option.value}
                type="radio"
                className="h-6 w-6 border-blue border-2 text-blue focus:ring-blue"
                checked={option.value === radioSelected}
                onChange={(e) => {
                  setRadioSelected(e.target.value)
                }}
              />
              <label
                htmlFor={option.value}
                className="ml-3 block text-[18px] lg:text-[22px] font-alliance-medium text-blue"
              >
                {option.title}
              </label>
            </div>
          ))}
        </div>
      </div>
    </fieldset>
  )
}

export default RadioFilter
